import {Button} from '@material-ui/core';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {resourcePlan, roleAdmin, roleOperator} from "../../constants";
import hasPermissions from "../../functions/permissions/hasPermissions";

interface MoveToPlanButtonProps {
    className?: string;
    onClick?: Function;
    label: string;
}

const MoveToPlanButton: React.FunctionComponent<MoveToPlanButtonProps> =
    ({className, onClick, label}: MoveToPlanButtonProps) => {
        const {t: translate} = useTranslation();

        const isAdmin = hasPermissions(roleAdmin);
        const isOperator = hasPermissions(roleOperator);

        if (isAdmin || isOperator) {
            return (<div/>);
        } else {
            return (
                <Link to={`/${resourcePlan}`}>
                    <Button
                        variant="contained"
                        className={`text-white ${className}`}
                        color="primary"
                        onClick={():void => {
                            if (onClick) {
                                onClick();
                            }
                        }}
                    >
                        {translate(label)}
                    </Button>
                </Link>
            );
        }
    };

export default MoveToPlanButton;